import React, { useEffect, useState } from 'react'
import MocklHeader from './MockHeader';
import Nav from '../master/NavBar';
import { formatDate, ToastMain ,SweetAlertShow} from '../master/Master';
import { StudentList } from '../../api/FeesDeposite';
import { testList } from '../../api/TestService';
import { Link } from 'react-router-dom';


const MockTestList = () => {
    const [loading, setLoading]=useState(false);
    const [data, setData]=useState('');
      const [List, setList] = useState([]);
      const [parent_id, setParentId] = useState(null);
      const [parent, setParent] = useState('')
      const [page, setPage] = useState(1)
      const [batch, setBatch] = useState();
      const [selectedBatchId, setSelectedBatchId] = useState("");
      const [search, setSearch] = useState('');
      const [sessions, setSessions] = useState([]);
      const [selectedSession, setSelectedSessions] = useState('');

      const fetchList = async () => {
        setLoading(true)
        let addUrl = `&page=${page}&parent_id=${parent}&batch_id=${selectedBatchId}&search=${search}&page=${page}&session_id=${selectedSession}`
        try {
          const response = await testList(addUrl);
          if (response.data.status) {
            setList(response?.data?.data);
          }
        } catch (error) {

          SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.response?.message ?? error?.message)
          // ToastMain.fire({
          //   icon: "error",
          //   title: error?.response?.data?.message || error?.response?.message || "Something Want Wrong!",
          // });
        } finally {
          setLoading(false)
        }
      };
    
      useEffect(() => {
        fetchList();
      }, [search, selectedBatchId, parent, page, selectedSession])


  return (
  <>
    {loading && (
          <div
            className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
            style={{ zIndex: 9999 }}
          >
            <div className="sk-chase sk-primary display-1">
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
              <div className="sk-chase-dot" />
            </div>
          </div>
        )}
  
        <div className="layout-wrapper layout-content-navbar">
          <div className="layout-container">
            <MocklHeader />
            <div className="layout-page">
              <Nav />
  
              <div className="container-fluid mt-2">
                <div className="row">
                  <div className="card">
                    <div className="card-body">
                      <h4>Mock test List</h4>
                    </div>
  
                    <div className="col-md-3 mb-2">
                      <div className="form-floating form-floating-outline">
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Search series ...."
                        />
                        <label htmlFor="">Search series</label>
                      </div>
                    </div>
                  </div>
  
                  <div className="card mt-2">
                    <div className="card-body">
                    <table className="table table-bordered text-center align-middle">
                                             <thead className="bg-primary text-white">
                                               <tr>
                                                 <th>#</th>
                                                 <th>Title</th>
                                                 <th>Total Marks</th>
                                                 <th>Date</th>
                                                 <th>Test Type</th>
                                                 <th>Series / Type</th>
                                                 <th>Action</th>
                                               </tr>
                                             </thead>
                                             <tbody>
                                               {List?.data?.map((item, index) => (
                                                 <tr key={index}>
                                                   <td>{index + 1}</td>
                                                   <td>{item?.title} {item?.series?.title && `(${item?.series?.title})`}</td>
                                                   <td>{item?.total_marks}</td>
                                                   <td>{formatDate(item?.date)}</td>
                                                   <td>
                                                     {item?.parent_id == null ? (
                                                       <span className="badge bg-warning text-dark">Without Series</span>
                                                     ) : (
                                                       <span className="badge bg-label-primary">With Series</span>
                                                     )}
                                                   </td>
                   
                   
                                                   <td>
                   
                                                     {item?.series?.type === '1' ? (
                                                       <span className="badge bg-label-info">Exam</span>
                                                     ) : (
                                                       <span className="badge bg-label-info ">Test</span>
                                                     )}
                                                   </td>
                   
                   
                                                   <td>
                                                     
                                                       <Link to={`/mock/test/panel?id=${item.id}`}>
                                                         <button
                                                           className="btn btn-outline-success btn-sm me-1"
                                                         // onClick={() => (window.location.href = "/tests/report")}
                                                         >
                                                           <i className="bi bi-eye-fill text-success" />
                                                         </button></Link>                                                                                                                                                                                                                                                                             
                                                   </td>
                                                 </tr>
                                               ))}
                                             </tbody>
                                           </table>
                                           <nav aria-label="Page navigation" className="mt-10">
                                             <p>
                                               Showing {List?.from} to {List?.to} of{" "}
                                               {List?.total} entries
                                             </p>
                                             <ul className="pagination pagination-sm">
                                               {List?.links?.map((btn, i) => (
                                                 <li
                                                   className={`page-item  ${btn?.active && "active"
                                                     }  ${btn?.url ? "" : "disabled"} `}
                                                 >
                                                   <button
                                                     className="page-link waves-effect"
                                                     onClick={() => {
                                                       if (List?.links?.length === i + 1) {
                                                         btn?.url &&
                                                           setPage(List?.current_page + 1);
                                                       } else if (i === 0) {
                                                         btn?.url &&
                                                           setPage(List?.current_page - 1);
                                                       } else {
                                                         setPage(btn.label);
                                                       }
                                                     }}
                                                   >
                                                     {List?.links?.length == i + 1 ? (
                                                       <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                                                     ) : i == 0 ? (
                                                       <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                                                     ) : (
                                                       btn?.label
                                                     )}
                                                   </button>
                                                 </li>
                                               ))}
                                             </ul>
                                           </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  </>
  )
}

export default MockTestList
